import {useTheme} from 'styled-components';
import {useGetAppointmentsTelehealthDocsQuery} from '../../../../queries/useGetAppointmentsTelehealthDocsQuery';

export function useDocumentContainer(documentId: string) {
	const {data, isError, isLoading} = useGetAppointmentsTelehealthDocsQuery({
		health_requester_id: documentId,
	});
	const {colors} = useTheme();

	const {
		exames: examRequests,
		medicamentos: medications,
		atestados: sickNotes,
		relatorios: medicalReportsDocs,
	} = data?.prescription ?? {};

	const examRequestsIsEmpty =
		!examRequests || examRequests?.length === 0 || examRequests[0] === null;
	const medicationsIsEmpty = !medications || medications?.length === 0 || medications[0] === null;
	const sickNotesIsEmpty = !sickNotes || sickNotes?.length === 0 || sickNotes[0] === null;
	const medicalReportsIsEmpty =
		!medicalReportsDocs || medicalReportsDocs?.length === 0 || medicalReportsDocs[0] === null;

	const isEmpty =
		examRequestsIsEmpty && medicationsIsEmpty && sickNotesIsEmpty && medicalReportsIsEmpty;

	return {
		isEmpty,
		isLoading,
		isError,
		colors,
		data,
		sickNotesIsEmpty,
		medicalReportsIsEmpty,
		medicationsIsEmpty,
		examRequestsIsEmpty,
		sickNotes,
		medicalReportsDocs,
		medications,
		examRequests,
	};
}
